import { render, staticRenderFns } from "./reply-form.vue?vue&type=template&id=62450b3b&scoped=true&"
import script from "./reply-form.vue?vue&type=script&lang=js&"
export * from "./reply-form.vue?vue&type=script&lang=js&"
import style0 from "./reply-form.vue?vue&type=style&index=0&id=62450b3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62450b3b",
  null
  
)

export default component.exports